module.exports = __webpack_public_path__ + "img/cup_soup.8db6f375.png";